import {sanityFetch} from 'utils/sanity.fetch';

import {HeaderClient} from './client';
import type {ResolvedMainNavigationQueryResult} from './query';
import {RESOLVED_MAIN_NAVIGATION_QUERY} from './query';

export const HeaderServer = async () => {
	const mainNavigation = await sanityFetch<ResolvedMainNavigationQueryResult[]>({
		query: RESOLVED_MAIN_NAVIGATION_QUERY,
	});

	if (!mainNavigation) {
		return null;
	}

	return <HeaderClient mainNavigation={mainNavigation} />;
};
